import ActionType from '../actionTypes/snackbarActionType';
import { ISnackbarNotification } from '../../objects/app/snackbar';

export interface ISnackbarState {
    notifications: ICommonState;
}

interface ICommonState {
    notifications: ISnackbarNotification[];
}

interface NotificationAction {
    notification: ISnackbarNotification;
}
const stateNotifications = 'notifications';
type SubState = typeof stateNotifications;

const getInitialState = (): ISnackbarState => ({
    [stateNotifications]: {
        notifications: [],
    },
});

const addSnackbar = (
    subStateName: SubState,
    state: ISnackbarState,
    action: NotificationAction
): ISnackbarState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        notifications: [
            ...state[subStateName].notifications,
            action.notification,
        ],
    },
});

// const removeSnackbar = (
//     subStateName: SubState,
//     state: ISnackbarState,
//     action: NotificationAction
// ): ISnackbarState => ({
//     ...state,
//     [subStateName]: {
//         state[subStateName].notifications.filter(
//             notification => notification.key !== action.key,
//         )
//     },
// });

const reducer = (state = getInitialState(), action: any): ISnackbarState => {
    switch (action.type) {
        case ActionType.addSnackbar:
            return addSnackbar(stateNotifications, state, action);
        // case ActionType.REMOVE_SNACKBAR: return removeSnackbar(state, action);

        default:
            return state;
    }
};

export default reducer;
